import LandingPage from "./landingPage"
import NavBar from "./components/navbar"
import ChiSono from "./chiSono"
import Servizi from "./servizi"
import Contatti from "./contatti"
import Footer from "./footer"
export default function MainPage (){
    return (
        <>
            <NavBar></NavBar>
            <LandingPage></LandingPage>
            <ChiSono></ChiSono>
            <Servizi></Servizi>
            <Contatti></Contatti>
            <Footer></Footer>
        </>
    )
}